var map = {
	"./fetish.svg": 757,
	"./fetish_avatar.svg": 3403,
	"./gays.svg": 2610,
	"./gays_avatar.svg": 8974,
	"./kaufmich.png": 920,
	"./kaufmich_avatar.png": 1258,
	"./poppen.svg": 7948,
	"./poppen_avatar.svg": 5352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9876;